<template>
  <div>
    <div class="hidden md:inline">
      <ul :class="['flex flex-wrap items-end text-xs md:text-base mb-0', dark ? 'border-gray-200' : 'border-gray-150', { 'border-b': !noBorder }]">
        <li
          v-for="tab in sharedState.tabs"
          :key="tab.title"
          :class="[
            'cursor-pointer py-2 mr-6 font-normal text-sm -mb-px border-b-2',
            { 'is-active border-primary-500 transition-all duration-100': sharedState.activeTabTitle === tab.title },
            sharedState.activeTabTitle === tab.title ? active : nonActive,
          ]"
          @click.prevent="selectTab(tab)"
        >
          {{ tab.title }}
        </li>
      </ul>
    </div>
    <div class="inline md:hidden">
      <base-select light :filter-from-children="true" :options="tabOptions" @update:model-value="selectTabByTitle" :model-value="sharedState.activeTabTitle" />
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>
<script>
import BaseSelect from "@/components/base/BaseSelect";
import { reactive } from "vue";

export default {
  components: {
    BaseSelect,
  },

  emits: ["click"],

  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
  },

  provide() {
    return {
      tabsState: this.sharedState,
      registerTab: this.registerTab,
      unregisterTab: this.unregisterTab,
    };
  },

  data() {
    return {
      sharedState: reactive({
        activeTabTitle: "",
        tabs: [],
      }),
    };
  },

  computed: {
    active() {
      return "text-primary-500";
    },

    nonActive() {
      return "text-gray-400 hover:border-gray-400 border-transparent";
    },

    tabOptions() {
      return this.sharedState.tabs.map((tab) => ({
        label: tab.title,
        value: tab.title,
      }));
    },
  },

  methods: {
    registerTab(tab) {
      const exists = this.sharedState.tabs.find((t) => t.title === tab.title);

      if (!exists) {
        this.sharedState.tabs.push(tab);
      }

      // Only select when explicitly selected
      if (tab.selected) {
        this.sharedState.activeTabTitle = tab.title;
      }
    },

    unregisterTab(title) {
      const index = this.sharedState.tabs.findIndex((t) => t.title === title);

      if (index > -1) {
        this.sharedState.tabs.splice(index, 1);
      }
    },

    selectTab(selectedTab) {
      this.sharedState.activeTabTitle = selectedTab.title;
      this.$emit("click", selectedTab.title);
    },

    selectTabByTitle(title) {
      const tab = this.sharedState.tabs.find((t) => t.title === title);

      if (tab) {
        this.selectTab(tab);
      }
    },
  },
};
</script>
